<div class="footer-main">
  <div class="footer-inner">
    <div class="left-side">
      <div class="logo">
        <a routerLink="/">
          <img [src]="s3BucketUrl + '/ASSETS/GENERAL/LOGO/footer-logo-white.svg'" width="202" height="57"
               alt="logo" loading="lazy" appHandleImageError>
        </a>
      </div>
      <div class="social-media">
        <p class="social-media-title">Join us on social media</p>
        <div class="social-media-icon">
          <a [href]="facebookUrl" rel="noopener noreferrer nofollow" aria-label="Facebook" target="_blank" class="icon">
            <img [src]="s3BucketUrl + '/ASSETS/GENERAL/ICONS/facebook-icon-white.svg'" width="32" height="32"
                 alt="Facebook" appHandleImageError>
          </a>
          <a [href]="instagramUrl" rel="noopener noreferrer nofollow" aria-label="Instagram" target="_blank" class="icon">
            <img [src]="s3BucketUrl + '/ASSETS/GENERAL/ICONS/instagram-icon-white.svg'" width="32" height="32"
                 alt="Instagram" appHandleImageError>
          </a>
          <a [href]="pinterestUrl" rel="noopener noreferrer nofollow" aria-label="Pinterest" target="_blank" class="icon">
            <img [src]="s3BucketUrl + '/ASSETS/GENERAL/ICONS/pinterest-icon-white.svg'" width="32" height="32"
                 alt="Pinterest" appHandleImageError>
          </a>
        </div>
      </div>
    </div>
    <div class="center-side" [class.flex-auto]="isUserAuthenticated !== false">
      <div class="footer-menu">
        <ul>
          <li class="menu-title">
            About
          </li>
          <li>
            <a class="nav-link" [routerLink]="ROUTES.OUR_STORY" routerLinkActive="active">
              Our Story
            </a>
          </li>
          <li>
            <a class="nav-link" [routerLink]="ROUTES.GATHER_COMMITMENT" routerLinkActive="active">
              Gather Commitment
            </a>
          </li>
          <li>
            <a class="nav-link" [routerLink]="ROUTES.TILES_FOR_SMILES" routerLinkActive="active">
              Tiles for Smiles
            </a>
          </li>
          <li>
            <a class="nav-link" [routerLink]="ROUTES.FEATURE_PROJECTS.ROOT" routerLinkActive="active">
              Projects
            </a>
          </li>
          <li>
            <a class="nav-link" [routerLink]="ROUTES.BLOGS.ROOT" routerLinkActive="active">
              Blogs
            </a>
          </li>
        </ul>
        <ul>
          <li class="menu-title">
            Products
          </li>
          <li>
            <a class="nav-link" [routerLink]="ROUTES.FLOORING.ROOT" routerLinkActive="active">
              Flooring
            </a>
          </li>
          <li>
            <a class="nav-link" [routerLink]="ROUTES.WALLING.ROOT" routerLinkActive="active">
              Walling
            </a>
          </li>
          <li>
            <a class="nav-link outlet" [routerLink]="ROUTES.OUTLET.ROOT" routerLinkActive="active">
              Outlet
            </a>
          </li>
        </ul>
        <ul>
          <li class="menu-title">
            Support
          </li>
          <li>
            <a class="nav-link" [routerLink]="ROUTES.RESOURCE_HUB" routerLinkActive="active">
              Resource Hub
            </a>
          </li>
          @if (isPlatformBrowser(this.platformId)) {
          <li>
            @if (isUserAuthenticated) {
              <a class="nav-link" [routerLink]="[ROUTES.PRICE_LIST]" routerLinkActive="active"
                 (click)="!isUserAuthenticated ? handleError() : null">
                Price List
              </a>
            } @else {
              <span class="nav-link grey-price-menu" placement="auto"
                  [ngbTooltip]="CommonConstants.PRICE_MENU_TOOLTIP_MESSAGE">Price List</span>
            }
          </li>
          }
          <li>
            <a class="nav-link" [routerLink]="ROUTES.FAQ" routerLinkActive="active">
              FAQ
            </a>
          </li>
          <li>
            <a class="nav-link" [routerLink]="ROUTES.CONTACT" routerLinkActive="active">
              Contact
            </a>
          </li>
        </ul>
      </div>
    </div>
    @if (isUserAuthenticated == false) {
      <div class="right-side sign">
        <p class="right-side-content">Construction industry professional?</p>
        <h3 class="right-side-title">REGISTER FOR FULL ACCESS</h3>
        <button type="button" class="btn btn-primary" (click)="openSignUpModal()">
          <span class="btn-primary-hover"></span>
          <span class="btn-content">Get Started</span>
        </button>
      </div>
    }
  </div>
</div>
<div class="copyright-section" [class]="productDetailClass">
  <div class="copyright">
    <p class="copyright-content">&#64;{{ currentYear }} GatherCo. All rights reserved
<!--      | Designed and developed by-->
<!--      <a href="https://www.encodedots.com/" target="_blank">-->
<!--        <img-->
<!--          [src]="s3BucketUrl + '/ASSETS/GENERAL/LOGO/encodedots-logo.svg'" width="131" height="19"-->
<!--          alt="Encodedots" loading="lazy" appHandleImageError>-->
<!--      </a>-->
    </p>
  </div>
  <div class="copyright-left-side">
    <img [src]="s3BucketUrl + '/ASSETS/GENERAL/LOGO/pay-advantage-icon-white.svg'" alt="Pay Advantage"  width="106" height="22" loading="lazy"
         appHandleImageError>
    <img [src]="s3BucketUrl + '/ASSETS/GENERAL/LOGO/b-pay-icon-white.svg'" alt="BPAY" loading="lazy" width="50" height="22" appHandleImageError>
    <img [src]="s3BucketUrl + '/ASSETS/GENERAL/LOGO/visa-icon-white.svg'" alt="VISA" loading="lazy" width="44" height="15" appHandleImageError>
    <img [src]="s3BucketUrl + '/ASSETS/GENERAL/LOGO/master-card-icon-white.svg'" alt="MASTER Card"  width="35" height="22"  loading="lazy"
         appHandleImageError>
    <img [src]="s3BucketUrl + '/ASSETS/GENERAL/LOGO/american-express-icon-white.svg'" alt="American Express"  width="38" height="25" loading="lazy"
         appHandleImageError>
  </div>
  <div class="copyright-right-side">
    <ul>
      <li><a [routerLink]="['/', ROUTES.TERMS_AND_CONDITIONS]" routerLinkActive="active" class="nav-link">Terms and Conditions</a>
      </li>
      <li><a [routerLink]="['/', ROUTES.PRIVACY_POLICY]" routerLinkActive="active" class="nav-link">Privacy and Policy</a></li>
    </ul>
  </div>
</div>
